export default [
  {
    path: "/feeConfigurations",
    component: () => import(/* webpackChunkName: "withdraws" */ "./layout"),

    children: [
      {
        path: "/feeConfigurations/withdraws",
        name: "withdraws.index",
        component: () => import(/* webpackChunkName: "withdraws" */ "./index"),
      },
      {
        path: "/feeConfigurations/:id/withdraws/offers",
        props: true,
        name: "withdraws.offers.index",
        component: () => import(/* webpackChunkName: "withdraws" */ "./offers/index"),
      },
      {
        path: "/feeConfigurations/:feeConfigurationId/withdrawOffers/:id",
        props: true,
        name: "withdraws.offers.show",
        component: () => import(/* webpackChunkName: "deposits.payinmethods" */ "./offers/show"),
      },
      {
        path: "/feeConfigurations/:id/withdraws/countries",
        props: true,
        name: "withdraws.countries.index",
        component: () => import(/* webpackChunkName: "withdraws.countries" */ "./countries/index"),
      },
      {
        path: "/feeConfigurations/:feeConfigurationId/countries/:id",
        props: true,
        name: "withdraws.countries.show",
        component: () => import(/* webpackChunkName: "withdraws.countries" */ "./countries/show"),
      },
      {
        path: "/feeConfigurations/:id/withdraws/payoutMethods",
        props: true,
        name: "withdraws.payoutmethods.index",
        component: () =>
          import(/* webpackChunkName: "withdraws.countrymappings" */ "./payoutMethods/index"),
      },
      {
        path: "/feeConfigurations/:feeConfigurationId/payOutMethods/:id",
        props: true,
        name: "withdraws.payoutmethods.show",
        component: () =>
          import(/* webpackChunkName: "withdraws.payoutmethods.show" */ "./payoutMethods/show"),
      },
    ],
  },
];
